<section class="hero">
  <div class="hero-overlay"></div>

  <div class="hero-content">
    <div class="hero-text">
      <span class="eyebrow">SOLUPRIME ERP</span>

      <h1>
        Software contable para oficinas contables y pequeñas empresas.
      </h1>

      <p>
        <strong>Soluprime ERP</strong> permite administrar empresas, usuarios,
        plan de cuentas, asientos contables, libros, balances y control de caja
        desde una sola plataforma web.
      </p>

      <div class="hero-actions">
        <a routerLink="/contacto" class="btn primary">Solicitar demostración</a>
        <a href="#funcionalidades" class="btn secondary">Ver funcionalidades</a>
      </div>

      <div class="hero-stats" aria-label="Fortalezas de Soluprime ERP">
        <div>
          <strong>ERP</strong>
          <span>Gestión contable centralizada</span>
        </div>
        <div>
          <strong>Web</strong>
          <span>Acceso desde cualquier lugar</span>
        </div>
        <div>
          <strong>Caja</strong>
          <span>Control de liquidez y saldos</span>
        </div>
      </div>
    </div>

    <div class="hero-card">
      <img src="assets/logo-solusoft.jpg" alt="Soluprime ERP" class="logo" />
      <h2>Soluprime ERP</h2>
      <p>Contabilidad, gestión y control para oficinas contables y pequeñas empresas.</p>
    </div>
  </div>
</section>

<section class="section" id="funcionalidades">
  <div class="section-header">
    <span class="section-kicker">Producto principal</span>
    <h2>Un ERP contable creado para ordenar la gestión diaria</h2>
    <p>
      <strong>Soluprime ERP</strong> simplifica el trabajo contable, mejora el
      control de la información y entrega una experiencia clara para usuarios
      administrativos, contadores y empresas.
    </p>
  </div>

  <div class="services-grid">
    <article class="service-card">
      <div class="icon">🏢</div>
      <h3>Multiempresa</h3>
      <p>Administra distintas empresas desde una misma plataforma.</p>
    </article>

    <article class="service-card">
      <div class="icon">👥</div>
      <h3>Usuarios y roles</h3>
      <p>Control de accesos por perfil: administración, oficina y usuarios operativos.</p>
    </article>

    <article class="service-card">
      <div class="icon">📘</div>
      <h3>Plan de cuentas</h3>
      <p>Gestión estructurada de cuentas contables por empresa.</p>
    </article>

    <article class="service-card">
      <div class="icon">🧾</div>
      <h3>Asientos contables</h3>
      <p>Registro de movimientos con validaciones y control de debe/haber.</p>
    </article>
  </div>
</section>

<section class="products-section">
  <div class="product-card dark">
    <span class="section-kicker">Producto principal</span>
    <h2>Soluprime ERP</h2>
    <p>
      Software web para oficinas contables y pequeñas empresas, con administración
      de empresas, usuarios, asientos, libros contables, balances y control de caja.
    </p>
    <a routerLink="/contacto" class="btn light">Solicitar información</a>
  </div>
</section>